import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cachios from 'cachios';
import { getAccessToken, logout, getDeviceId, setAccessToken, runAuthConnectors } from "./auth";
import axios from 'axios';
var a = axios.create();
var globTimers = [];

function createRefresh(config) {
  /*setTimeout(function() {
      let cacher = cachios.create(a)
      let x = cacher(config).then(result => {
          createRefresh(config)
      }).catch(error => {
          createRefresh(config)
      });
  }, 10000);*/
}

function autoRefreshData(config) {
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, 10000 || 1000);
  }); // Return the promise in which recalls axios to retry the request

  return backoff.then(function () {
    return a(config);
  });
}

function createCustomAxios() {
  a.interceptors.response.use(function axiosSuccessInterceptor(succ) {
    createRefresh(succ.config);
    return succ;
  }, function axiosRetryInterceptor(err) {
    var stat = err.response.status;
    if (stat >= 400 && stat < 500) return Promise.reject(err);
    var config = err.config; // If config does not exist or the retry option is not set, reject

    if (!config || !config.retry) return Promise.reject(err); // Set the variable for keeping track of the retry count

    config.__retryCount = config.__retryCount || 0; // Check if we've maxed out the total number of retries

    if (config.__retryCount >= config.retry) {
      // Reject with the error
      createRefresh(config);
      return Promise.reject(err);
    } // Increase the retry count


    config.__retryCount += 1; // Create new promise to handle exponential backoff

    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay * config.__retryCount || 1000);
    }); // Return the promise in which recalls axios to retry the request

    return backoff.then(function () {
      return a(config);
    });
  });
  return a;
}

var instance = createCustomAxios();
var cacher = cachios.create(instance);
export function InvalidateCacheAndCreateNew() {
  a = axios.create();
  instance = createCustomAxios();
  cacher = cachios.create(instance);
}
export function DeliverRequest(_x, _x2) {
  return _DeliverRequest.apply(this, arguments);
}

function _DeliverRequest() {
  _DeliverRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(toSend, masterEndpoint) {
    var shouldBackgroundRefresh,
        ttlInMinutes,
        useCacheIfAvailable,
        withExtraHeaders,
        config,
        RetryStrategy,
        _RetryStrategy,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _RetryStrategy = function _RetryStrategy3() {
              _RetryStrategy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        return _context.abrupt("return", cacher.post(global.baseUrl + "/", toSend, config).then(function (result) {
                          if (result.status === 200) {
                            if (typeof result.data.token === "string") {
                              setAccessToken(result.data.token);

                              if (result.data.reauthenticated) {
                                InvalidateCacheAndCreateNew();
                                global.isAuthenticated = true;
                                runAuthConnectors();
                                global.viewConnectors.forEach(function (connection) {
                                  connection.connect();
                                });
                                global.searchConnectors.forEach(function (connection) {
                                  connection.connect();
                                });
                              }
                            }

                            return {
                              success: true,
                              result: result.data.data,
                              response: result.status
                            };
                          }
                        }).catch(function (result) {
                          if (result.response.status === 401) {
                            logout();
                            return {
                              success: false,
                              result: "Please login again",
                              response: result.response.status
                            };
                          } else if (result.response.status === 412) {
                            return {
                              success: false,
                              result: "Unable to connect to cross-domain resource."
                            };
                          } else {
                            if (result.response && result.response.data && result.response.data.errorMessage) {
                              return {
                                success: false,
                                result: result.response.data.errorMessage,
                                response: result.response.status
                              };
                            } else if (result.response && result.response.statusText) {
                              return {
                                success: false,
                                result: result.response.statusText,
                                response: result.response.status
                              };
                            } else {
                              return {
                                success: false,
                                result: "Your internet connection may be offline. Check it and refresh this page."
                              };
                            }
                          }
                        }));

                      case 4:
                        _context.prev = 4;
                        _context.t0 = _context["catch"](0);
                        return _context.abrupt("return", {
                          success: false,
                          result: ""
                        });

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 4]]);
              }));
              return _RetryStrategy.apply(this, arguments);
            };

            RetryStrategy = function _RetryStrategy2() {
              return _RetryStrategy.apply(this, arguments);
            };

            shouldBackgroundRefresh = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            ttlInMinutes = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 2;
            useCacheIfAvailable = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : true;
            withExtraHeaders = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : {};
            _context2.t0 = _objectSpread;
            _context2.next = 9;
            return getAccessToken();

          case 9:
            _context2.t1 = _context2.sent;
            _context2.t2 = masterEndpoint;
            _context2.t3 = {
              Authorization: _context2.t1,
              Endpoint: _context2.t2
            };
            _context2.t4 = withExtraHeaders;
            _context2.t5 = (0, _context2.t0)(_context2.t3, _context2.t4);
            _context2.t6 = ttlInMinutes * 60;
            _context2.t7 = !useCacheIfAvailable;
            config = {
              headers: _context2.t5,
              ttl: _context2.t6,
              force: _context2.t7,
              retry: 10,
              retryDelay: 1500
            };
            _context2.next = 19;
            return getDeviceId();

          case 19:
            toSend.deviceId = _context2.sent;
            _context2.prev = 20;
            _context2.next = 23;
            return RetryStrategy();

          case 23:
            return _context2.abrupt("return", _context2.sent);

          case 26:
            _context2.prev = 26;
            _context2.t8 = _context2["catch"](20);
            return _context2.abrupt("return", {
              success: false,
              result: _context2.t8
            });

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[20, 26]]);
  }));
  return _DeliverRequest.apply(this, arguments);
}

export function ExternalRequest(_x3, _x4, _x5) {
  return _ExternalRequest.apply(this, arguments);
}

function _ExternalRequest() {
  _ExternalRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(method, toSend, endpoint) {
    var shouldBackgroundRefresh,
        ttlInMinutes,
        useCacheIfAvailable,
        withExtraHeaders,
        config,
        RetryStrategy,
        _RetryStrategy4,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _RetryStrategy4 = function _RetryStrategy6() {
              _RetryStrategy4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        return _context3.abrupt("return", cacher.request(_objectSpread({
                          url: endpoint,
                          data: toSend,
                          method: method.toLowerCase()
                        }, config)).then(function (result) {
                          if (result.status === 200) {
                            return {
                              success: true,
                              result: result.data,
                              response: result.status
                            };
                          }
                        }).catch(function (result) {
                          if (result.response && result.response.data && result.response.data) {
                            return {
                              success: false,
                              result: result.response.data,
                              response: result.response.status
                            };
                          } else {
                            return {
                              success: false,
                              result: "Your internet connection may be offline. Check it and refresh this page."
                            };
                          }
                        }));

                      case 4:
                        _context3.prev = 4;
                        _context3.t0 = _context3["catch"](0);
                        return _context3.abrupt("return", {
                          success: false,
                          result: ""
                        });

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[0, 4]]);
              }));
              return _RetryStrategy4.apply(this, arguments);
            };

            RetryStrategy = function _RetryStrategy5() {
              return _RetryStrategy4.apply(this, arguments);
            };

            shouldBackgroundRefresh = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : false;
            ttlInMinutes = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : 2;
            useCacheIfAvailable = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : true;
            withExtraHeaders = _args4.length > 6 && _args4[6] !== undefined ? _args4[6] : {};
            config = {
              headers: withExtraHeaders,
              ttl: ttlInMinutes * 60,
              force: !useCacheIfAvailable,
              retry: 10,
              retryDelay: 1500
            };
            _context4.prev = 7;
            _context4.next = 10;
            return RetryStrategy();

          case 10:
            return _context4.abrupt("return", _context4.sent);

          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](7);
            return _context4.abrupt("return", {
              success: false,
              result: _context4.t0
            });

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[7, 13]]);
  }));
  return _ExternalRequest.apply(this, arguments);
}